import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import IconSelect from "../../../../components/select/main/icon/IconSelect";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../../../styles/CardStyles";
import {
  StyledFlexColumn,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import {
  faCheck,
  faLink,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../../context/LanguageContext";
import Select from "../../../../components/select/main/Select";
import HiddenLoader from "../../../../components/loader/HiddenLoader/HiddenLoader";
import { StyledInput } from "../../../../styles/InputStyles";
import Form from "../../../../components/form/Form";

function SaltoIqsView({
  configData,
  iqLabels = {},
  availableIqs = [],
  onIqAdd,
  onIqPinChange,
  onIqDelete,
  onIqConnectionInit,
  onIqConnect,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="salto_configs_page_fetch">
      <StyledCard>
        <StyledCardHeader>
          <StyledFlexRow
            style={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 style={{ flex: 1 }}>{translate("eva.main.entities.iqs")}</h2>

            <IconSelect
              options={availableIqs.map((iq) => ({
                value: iq.id,
                label: iq.label,
              }))}
              icon={() => <FontAwesomeIcon icon={faPlus} />}
              style={{ marginLeft: "auto" }}
              onChange={(value) => onIqAdd(value)}
              disabled={availableIqs.length <= 0}
            />
          </StyledFlexRow>
        </StyledCardHeader>

        <StyledCardBody>
          <StyledFlexColumn>
            {configData?.iqs?.map((configIq) => (
              <StyledFlexRow
                key={configIq.iq_id}
                {...(configIq.connection_initiated && {
                  //While the pin is entered, the row is a form that confirms the connection
                  as: Form,
                  onSubmit: () => onIqConnect(configIq.iq_id),
                  loadingGroups: `salto_iq_connection_${configIq.iq_id}`,
                })}
                style={{
                  alignItems: "flex-end",
                  padding: theme.spacing.normal,
                  borderRadius: theme.radius.normal,
                  border: `1px solid ${theme.colors.primary.darkest}`,
                }}
              >
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.iqs.*.iq_id",
                  )}
                  required
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configIq.iq_id}
                    options={[
                      {
                        value: configIq.iq_id,
                        label: iqLabels[configIq.iq_id] || configIq.iq_id,
                      },
                    ]}
                    style={{ opacity: 1 }}
                    hideCaret={true}
                    disabled
                  />
                </InputWrapper>

                {configIq.connection_initiated && (
                  <InputWrapper
                    label={translate("eva.main.validation.attributes.pin")}
                    required
                  >
                    <StyledInput
                      type="text"
                      value={configIq.pin || ""}
                      placeholder="1234"
                      onChange={(e) =>
                        onIqPinChange(configIq.iq_id, e.target.value)
                      }
                    />
                  </InputWrapper>
                )}

                {!configIq.connected && configIq.id && (
                  <HiddenLoader
                    groups={`salto_iq_connection_${configIq.iq_id}`}
                  >
                    <StyledAltIconButton
                      {...(configIq.connection_initiated
                        ? { type: "submit" }
                        : {
                            onClick: () => onIqConnectionInit(configIq.iq_id),
                          })}
                    >
                      <FontAwesomeIcon
                        icon={configIq.connection_initiated ? faCheck : faLink}
                      />
                    </StyledAltIconButton>
                  </HiddenLoader>
                )}

                <StyledAltIconButton onClick={() => onIqDelete(configIq.iq_id)}>
                  <FontAwesomeIcon icon={faTrash} />
                </StyledAltIconButton>
              </StyledFlexRow>
            ))}
          </StyledFlexColumn>
        </StyledCardBody>
      </StyledCard>
    </OverlayLoader>
  );
}

export default SaltoIqsView;
